import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { getBrowserTimezoneName } from '@newo/toolkit/datetime';
import { APP_VERSION } from '@/const';

interface ISettingsFields {
    timeZone: string;
    isUTC: boolean;
}

interface ISettingsState {
    settings: ISettingsFields;
    setSettings: (fields: Partial<ISettingsFields>) => void;
}

const initialState = {
    settings: {
        timeZone: getBrowserTimezoneName(),
        isUTC: false
    }
};

const useSettingsStore = create<ISettingsState>()(
    persist(
        (set) => ({
            ...initialState,
            setSettings: (fields) => {
                set((state) => ({
                    settings: { ...state.settings, ...fields }
                }));
            }
        }),
        {
            name: 'app-store',
            storage: createJSONStorage(() => globalThis.localStorage),
            partialize: (state) => state,
            version: APP_VERSION
        }
    )
);
export default useSettingsStore;
